<template>
  <div :class="floating ? 'add-to-cart-mobile' : 'add-to-cart-mid-page'">
    <div class="add-to-cart-options">
      <ProductNotifyMe :product="product" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    ProductNotifyMe: defineAsyncComponent(
      () => import('@/components/Product/PDP/ProductNotifyMe'),
    ),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    floating: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
